export default "__VITE_ASSET__DvvnhvAd__"